import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng4SpinnerComponent } from './ng4-spinner.component';
import { Ng4SpinnerService } from './ng4-spinner.service';
import { Ng4DefaultSpinnerComponent } from '../ng4-default-spinner/ng4-default-spinner.component';
export class Ng4SpinnerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [Ng4SpinnerComponent,Ng4DefaultSpinnerComponent],
  providers:[Ng4SpinnerService],
  exports:[Ng4SpinnerComponent,Ng4DefaultSpinnerComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function Ng4SpinnerModule_tsickle_Closure_declarations() {
/** @type {?} */
Ng4SpinnerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Ng4SpinnerModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
